// Displays a single parallel corpus sentence pair (Tamang + Nepali + English).
// Never invents content: only renders what's in the entry fields.

interface ExampleBlockProps {
  tamang:     string
  nepali:     string
  englishAuto: string
  sentenceId: string
  index:      number  // 1 | 2 | 3
}

export function ExampleBlock({
  tamang,
  nepali,
  englishAuto,
  sentenceId,
  index,
}: ExampleBlockProps) {
  if (!tamang && !nepali) return null

  return (
    <div className="rounded-lg border border-stone-100 bg-white p-4 space-y-2">
      <div className="flex items-center gap-2 mb-1">
        <span className="text-xs font-semibold text-stone-400 uppercase tracking-wide">
          Example {index}
        </span>
        {sentenceId && (
          <span className="text-xs text-stone-300 font-mono">{sentenceId}</span>
        )}
      </div>

      {/* Tamang — prominent */}
      {tamang && (
        <p className="deva text-lg font-medium text-tamang-700 leading-relaxed">
          {tamang}
        </p>
      )}

      {/* Nepali */}
      {nepali && (
        <p className="deva text-base text-stone-600 leading-relaxed">
          <span className="text-xs font-semibold text-stone-400 mr-2">Nepali</span>
          {nepali}
        </p>
      )}

      {/* English (auto-translated) */}
      {englishAuto && (
        <p className="text-sm text-stone-400 italic leading-relaxed">
          <span className="not-italic text-xs font-semibold mr-1">English</span>
          {englishAuto}{' '}
          <span className="badge-auto not-italic">auto</span>
        </p>
      )}
    </div>
  )
}
